/**
 * PartnerColorIconsColor.jsx
 * Created by Destin Frasier on 02/21/19.
 */

import PartnerColorIconSingleton from './partnerColorIconSingleton';
import BaseIcon from '../BaseIcon';


class PartnerColorIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = PartnerColorIconSingleton;
    }
}

export class NationalArchivesColor extends PartnerColorIcon {}
NationalArchivesColor.defaultProps = {
    iconName: 'rec-icon-national-archives-color',
    iconClass: 'rec-icon-national-archives-color',
    alt: 'National Archives'
};

export class DOIColor extends PartnerColorIcon {}
DOIColor.defaultProps = {
    iconName: 'rec-icon-doi-color',
    iconClass: 'rec-icon-doi-color',
    alt: 'Bureau of Reclamation'
};

export class TVAColor extends PartnerColorIcon {}
TVAColor.defaultProps = {
    iconName: 'rec-icon-tva-color',
    iconClass: 'rec-icon-tva-color',
    alt: 'Tennessee Valley Authority'
};

export class TREColor extends PartnerColorIcon {}
TREColor.defaultProps = {
    iconName: 'rec-icon-tre-color',
    iconClass: 'rec-icon-tre-color',
    alt: 'Department of The Treasury'
};

export class NPSColor extends PartnerColorIcon {}
NPSColor.defaultProps = {
    iconName: 'rec-icon-nps-color',
    iconClass: 'rec-icon-nps-color',
    alt: 'National Park Service'
};

export class USACEColor extends PartnerColorIcon {}
USACEColor.defaultProps = {
    iconName: 'rec-icon-usace-color',
    iconClass: 'rec-icon-usace-color',
    alt: 'Army Corps of Engineers'
};

export class ForestServiceColor extends PartnerColorIcon {}
ForestServiceColor.defaultProps = {
    iconName: 'rec-icon-forest-service-color',
    iconClass: 'rec-icon-forest-service-color',
    alt: 'Forest Service'
};

export class NOAAColor extends PartnerColorIcon {}
NOAAColor.defaultProps = {
    iconName: 'rec-icon-noaa-color',
    iconClass: 'rec-icon-noaa-color',
    alt: 'National Oceanic and Atmospheric Administration'
};

export class BLMColor extends PartnerColorIcon {}
BLMColor.defaultProps = {
    iconName: 'rec-icon-blm-color',
    iconClass: 'rec-icon-blm-color',
    alt: 'Bureau of Land Management'
};

export class SmithsonianColor extends PartnerColorIcon {}
SmithsonianColor.defaultProps = {
    iconName: 'rec-icon-smithsonian-color',
    iconClass: 'rec-icon-smithsonian-color',
    alt: 'Smithsonian'
};

export class FWSColor extends PartnerColorIcon {}
FWSColor.defaultProps = {
    iconName: 'rec-icon-fws-color',
    iconClass: 'rec-icon-fws-color',
    alt: 'Fish & Wildlife'
};

export class DOTColor extends PartnerColorIcon {}
DOTColor.defaultProps = {
    iconName: 'rec-icon-dot-color',
    iconClass: 'rec-icon-dot-color',
    alt: 'Department of Transportation'
};

export class BEPColor extends PartnerColorIcon {}
BEPColor.defaultProps = {
    iconName: 'rec-icon-bep-color',
    iconClass: 'rec-icon-bep-color',
    alt: 'Bureau of Engraving and Printing'
};